import {Map} from 'immutable';

export const getManagerInsightsByStore = (state) => {
  const managerInsights = state.managerInsights;

  const selectedStoreId = managerInsights.get('selectedStoreId');

  if (!selectedStoreId) {
    return managerInsights.get('insights');
  } else {
    const insights = managerInsights.get('insights');
    const summary = insights.getIn([
      'summary',
      'subTeams',
      String(selectedStoreId),
    ]);

    return new Map({
      detail: insights.get('details'),
      summary: new Map({
        ...summary.toJS(),
        totalContentCount: insights.getIn(['summary', 'totalContentCount']),
      }),
      users: insights
        .get('users')
        .filter((user) => summary.get('userIds').indexOf(user.get('id')) >= 0),
      contents: summary.get('contents'),
    });
  }
};
